import SparkMD5 from 'spark-md5';

const CHUNK_SIZE = 2 * 1024 * 1024;

/**
 * Compute the base64 MD5 checksum ActiveStorage direct-upload presign expects.
 *
 * Garage (the S3 backend) re-computes the MD5 of the bytes it receives on the
 * presigned PUT and rejects with 400 BadDigest if it doesn't match. Web Crypto
 * deliberately omits MD5 (insecure), so we stream-hash the file in 2 MB chunks
 * with spark-md5 — the same library `@rails/activestorage` uses. Streaming
 * (rather than one ArrayBuffer) keeps large files from OOM-ing the tab.
 */
export const computeUploadChecksum = async (file: File): Promise<string> => {
  const spark = new SparkMD5.ArrayBuffer();
  for (let offset = 0; offset < file.size; offset += CHUNK_SIZE) {
    const buf = await file.slice(offset, offset + CHUNK_SIZE).arrayBuffer();
    spark.append(buf);
  }
  return btoa(spark.end(true));
};
